import { REHYDRATE } from 'redux-persist';
import { SET_HELP_CURRENTPAGE, RESET_HELP, SET_TOUR_RUNNING,
         SET_ACTIVE_TOUR_SCREEN, SET_ACTIVE_TOUR_STEP,
         SET_TOUR_RECORD_IDS } from '../actions/types';

const initialState = {
    current: {},
    tourRunning: false,
    // activeTourScreen: which screen's tour is currently running, or null.
    // Read by tourInterceptor.js to decide whether to return canned mock
    // responses for matching API calls.
    activeTourScreen: null,
    // activeTourStep: id of the step currently displayed (e.g. 'cultivation-
    // hub-rooms'), or null. Read by useAdvanceOnStep so screen click handlers
    // can programmatically advance the tour ONLY when on the matching step,
    // avoiding accidental skips if the user clicks the wrong element.
    activeTourStep: null,
    // The swap a running detail tour performed on the screen's record id.
    // tourMockRecordId is the simulated record's _id, tourRealRecordId the
    // id from the URL that it displaced. Widgets that are never part of the
    // simulation — comments, attachments, print — read these through
    // useRecordIdForFetch (helpers/useTour.js) so they keep pointing at the
    // record the user actually has open. Both null when no tour is running.
    tourMockRecordId: null,
    tourRealRecordId: null
};

function help(state = initialState, action){
  switch(action.type){
    case REHYDRATE: {
      // Runtime-only fields shouldn't survive a page reload — a refresh
      // mid-tour would otherwise resurface a stale activeTourScreen and the
      // interceptor would keep serving mocks. Always boot with the tour
      // flags cleared; preserve `current` (the per-page help article cache).
      const persisted = action.payload?.help;
      if (!persisted) return state;
      return {
        ...persisted,
        tourRunning: false,
        activeTourScreen: null,
        activeTourStep: null,
        tourMockRecordId: null,
        tourRealRecordId: null
      };
    }
    case SET_HELP_CURRENTPAGE: {
      return { ...state, current: action.payload.current };
    }
    case RESET_HELP: {
      return initialState;
    }
    case SET_TOUR_RUNNING: {
      return { ...state, tourRunning: !!action.payload };
    }
    case SET_ACTIVE_TOUR_SCREEN: {
      // Clearing the active screen also clears the active step — they
      // always travel together (a tour either has a current step or it
      // isn't running).
      const screen = action.payload || null;
      return {
        ...state,
        activeTourScreen: screen,
        activeTourStep: screen ? state.activeTourStep : null,
        tourMockRecordId: screen ? state.tourMockRecordId : null,
        tourRealRecordId: screen ? state.tourRealRecordId : null
      };
    }
    case SET_ACTIVE_TOUR_STEP: {
      return { ...state, activeTourStep: action.payload || null };
    }
    case SET_TOUR_RECORD_IDS: {
      return {
        ...state,
        tourMockRecordId: action.payload?.mockId || null,
        tourRealRecordId: action.payload?.realId || null
      };
    }
    default:
      return state;
  }
}

export default help;
